import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Product, SortOption, ViewMode, ProductFilters } from '@/types';

interface ProductState {
  items: Product[];
  featured: Product[];
  newArrivals: Product[];
  bestSellers: Product[];
  deals: Product[];
  selectedProduct: Product | null;
  filters: ProductFilters;
  sortBy: SortOption;
  viewMode: ViewMode;
  isLoading: boolean;
  error: string | null;
}

const initialFilters: ProductFilters = {
  categories: [],
  brands: [],
  sports: [],
  priceRange: [0, 50000],
  ratings: [],
  availability: 'all',
  discount: null,
  genders: [],
  ageGroups: [],
  colors: [],
  sizes: [],
  materials: [],
};

const initialState: ProductState = {
  items: [],
  featured: [],
  newArrivals: [],
  bestSellers: [],
  deals: [],
  selectedProduct: null,
  filters: initialFilters,
  sortBy: 'relevance',
  viewMode: 'grid',
  isLoading: false,
  error: null,
};

export const productSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts: (state, action: PayloadAction<Product[]>) => {
      state.items = action.payload;
    },
    setFeatured: (state, action: PayloadAction<Product[]>) => {
      state.featured = action.payload;
    },
    setNewArrivals: (state, action: PayloadAction<Product[]>) => {
      state.newArrivals = action.payload;
    },
    setBestSellers: (state, action: PayloadAction<Product[]>) => {
      state.bestSellers = action.payload;
    },
    setDeals: (state, action: PayloadAction<Product[]>) => {
      state.deals = action.payload;
    },
    setSelectedProduct: (state, action: PayloadAction<Product | null>) => {
      state.selectedProduct = action.payload;
    },
    setFilters: (state, action: PayloadAction<Partial<ProductFilters>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters: (state) => {
      state.filters = initialFilters;
    },
    setSortBy: (state, action: PayloadAction<SortOption>) => {
      state.sortBy = action.payload;
    },
    setViewMode: (state, action: PayloadAction<ViewMode>) => {
      state.viewMode = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const productActions = productSlice.actions;
